<template>
  <div class="outerBox">
    <nav-bar fixed z-index="99" :title="title" left-text="返回" left-arrow @click-left="toBack" />
    <!-- van-pull-refresh：下拉刷新 -->
    <PullRefresh v-model="isLoading" @refresh="onRefresh">
      <div>
        <checkbox-group v-model="checkResult">
          <checkbox v-for="(item, index) in list" :disabled="$route.query.type != 11" :key="index" :name="item.id">
            <template v-if="$route.query.type != 11" #icon>
              <div></div>
            </template>

            <div class="cash-item" :class="{'account-public': shouldShowAccountType(item) && item.accountType === 1, 'account-private': shouldShowAccountType(item) && item.accountType === 0}">
              <!-- 账户类型标签 - 只有在提现中和已提现状态下显示，且accountType不为null -->
              <div class="account-type-tag" v-if="shouldShowAccountType(item) && item.accountType !== null">
                {{ item.accountType === 1 ? '公户' : (item.accountType === 0 ? '个户' : '') }}
              </div>

              <div class="cash-item-sa">
                订单编号：{{ item.orderId }}
              </div>
              <div class="cash-item-sa">
                创建时间：{{ item.createTime }}
              </div>
              <div class="cash-item-sa" v-if="item.withdrawTime">
                提现时间：{{ item.withdrawTime }}
              </div>
              <div class="cash-item-sa">
                用户姓名：{{ item.realName || '-' }}
              </div>
              <div class="cash-item-sa">
                订单金额：¥{{ item.payPrice }}
              </div>
              <!-- 新增退款金额字段，只在满足条件时显示 -->
              <div class="cash-item-sa" v-if="showRefundPrice(item)">
                退款金额：¥{{ item.refundPrice }}
              </div>
              <div class="cash-item-sa">
                教练分成：¥{{ item.giveawayAmount }}
              </div>
              <div class="cash-item-sa" v-if="incomePayData.type != 11">
                实际到账：¥{{ item.realPrice != null ? item.realPrice : item.giveawayAmount }}(含个税)
              </div>
            </div>
          </checkbox>
        </checkbox-group>
        <div v-if="list.length === 0" class="empty-list">
          暂无数据
        </div>
      </div>
    </PullRefresh>
    <!-- 申请提现按钮 -->
    <div class="apply-cash" @click="applyCash" v-show="checkResult.length > 0">
      <div class="apply-cash-btn" style="">申请提现</div>
    </div>
  </div>
</template>
<script>
import { List, PullRefresh, NavBar, Checkbox, CheckboxGroup } from 'vant'
import { getOrderList } from '@/api/order'
import Decimal from 'decimal.js';

export default {
  components: {
    PullRefresh,
    List,
    NavBar,
    Checkbox,
    CheckboxGroup
  },
  computed: {
    title(){
      if(this.$route.query.type == 11){
        return '未提现列表'
      }else if(this.$route.query.type == 12){
        return '提现中列表'
      }else if(this.$route.query.type == 13){
        return '已提现列表'
      }
    }
  },
  data() {
    return {
      //传递给后端的参数
      incomePayData: {
        page: 1, //请求第几页
        limit: 500, //每页请求的数量
        type: this.$route.query.type //订单类型
      },
      list: [], //列表数据
      isLoading: false, //下拉刷新
      checkResult: [] //选中的数据
    }
  },
  mounted() {
    this.getPassAnalysisList(); //列表数据接口
  },
  methods: {
    //列表数据接口
    getPassAnalysisList() {
      getOrderList(this.incomePayData).then(res => {
        if (res.success) {
          this.list = res.data.filter(item =>
          item._status && (
          item.status== 4 ||
          item._status._type === "4" ||
          (item._status._type === "-2" && item.payPrice - item.refundPrice > 0))
          );
          console.log("控制台输出", res.data);
        }
      })
    },
    // 判断是否显示退款金额
    showRefundPrice(item) {
      return item.refundPrice !== null && item.refundPrice > 0;
    },
    // 判断是否应该显示账户类型
    shouldShowAccountType(item) {
      return this.$route.query.type == 12 || this.$route.query.type == 13;
    },
    //下拉刷新
    onRefresh() {
      console.log("下拉刷新");
      // 清空当前数据
      this.list = [];
      // 保证刷新后页码重置为第一页
      this.incomePayData.page = 1;

      // 请求新数据
      getOrderList(this.incomePayData).then(res => {
        if (res.success) {
          this.list = res.data.filter(item =>
            item._status && (
              item.status== 4 ||
              item._status._type === "4" ||
              (item._status._type === "-2" && item.payPrice - item.refundPrice > 0)
            )
          );
          // 完成刷新
          this.isLoading = false;
          this.$toast('刷新成功');
        } else {
          this.isLoading = false;
          this.$toast('刷新失败');
        }
      }).catch(() => {
        this.isLoading = false;
        this.$toast('刷新失败');
      });
    },
    // 申请提现
    applyCash() {
      if (this.checkResult.length === 0) {
        this.$toast('请选择要提现的订单')
        return
      } else {
        // 计算所选中的订单的总金额
        let total = 0
        let totalAll = 0
        const orderList = []
        this.list.map(item => {
          if (this.checkResult.includes(item.id)) {
            let a = new Decimal(total);
            let aAll = new Decimal(totalAll);
            let b = new Decimal(item.giveawayAmount);
            let bAll = new Decimal(item.payPrice);
            total = a.plus(b)
            totalAll = aAll.plus(bAll)
            orderList.push(item.orderId)
          }
        })

        this.$router.push({
          path: '/user/user_cash_list_apply',
          query: {
            money: total,
            moneyAll: totalAll,
            orderList: orderList.join(',')
          }
        })
      }
    },
    toBack() {
      if (this.$route.query.from === 'home') {
        this.$router.push({ path: '/' })
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>
<style scoped lang="scss">
/* 外层盒子的样式 */
.outerBox {
  /* padding: 10px;
      box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3),
          0px 0px 20px rgba(0, 0, 0, 0.1) inset;
      margin: 30px 16px 16px 16px;
      overflow: hidden; */
  padding: 0 0.2rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
  // height: 100%;
}

.van-pull-refresh {
  min-height: 80vh;
}

.empty-list {
  text-align: center;
  padding: 2rem 0;
  color: #999;
  font-size: 0.28rem;
}

::v-deep .van-checkbox__label {
  width: 100%;
}
.van-checkbox{
  background-color: #0ce6df21;
  padding-left:0px;
  margin-bottom: 5px;
}
.cash-item {
  width: 100%;
  padding: 0.3rem;
  border-bottom: 1px solid #eee;
  position: relative;

  &-sa {
    font-size: 0.3rem;
    color: #333;
    margin-bottom: 0.1rem;
  }
}

/* 账户类型相关样式 */
.account-public {
  border-left: 4px solid #2c8ef8;
  background-color: rgba(44, 142, 248, 0.05);
}

.account-private {
  border-left: 4px solid #ff9800;
  background-color: rgba(255, 152, 0, 0.05);
}

.account-type-tag {
  position: absolute;
  top: 0;
  right: 0;
  padding: 0.1rem 0.3rem;
  font-size: 0.26rem;
  color: white;
  border-bottom-left-radius: 8px;
}

.account-public .account-type-tag {
  background-color: #2c8ef8;
}

.account-private .account-type-tag {
  background-color: #ff9800;
}

.apply-cash {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #fff;

  .apply-cash-btn {
    width: 100%;
    height: 0.88rem;
    line-height: 0.88rem;
    text-align: center;
    background-color: #ff6a3f;
    color: #fff;
    font-size: 0.32rem;
  }
}
</style>
